<template>
  <div class="invoice-history-row">
    <!-- <input type="checkbox" class="invoice-history-row__checkbox"> -->
    <img
      class="invoice-history-row__image"
      :src="`https://www.olssonparts.com/productImage/${invoiceRow.articleNumber}`">
    <div class="invoice-history-row__container">
      <div class="invoice-history-row__name">
        <p class="invoice-history-row__description">
          {{ invoiceRow.itemDescription }}
        </p>
        <p>{{ tStatic('articleNumberLabel') }}: <a class="invoice-history-row__link" :href="invoiceRow.url">{{ invoiceRow.articleNumber }}</a></p>
      </div>
      <div class="invoice-history-row__price">
        <p v-if="invoiceRow.machineName" class="invoice-row__machine">
          <button :aria-label="`Open machine ${invoiceRow.machineName}`" @click="handleSelectMachine(invoiceRow.machineID)">
            <oie-base-icon icon="machine" size="m"></oie-base-icon> {{ invoiceRow.machineName }}
          </button>
        </p>
      </div>
      <div class="invoice-history-row__price">
        <p>{{ t('quantity') }}</p>
        <p>{{ `${invoiceRow.quantity}` }}</p>
      </div>
      <div class="invoice-history-row__price">
        <p>{{ t('itemPrice') }}</p>
        <p>{{ formatPrice(invoiceRow.unitPrice) }}</p>
      </div>

      <div class="invoice-history-row__price">
        <p>{{ t('totalPrice') }}</p>
        <p>{{ formatPrice(invoiceRow.rowSum) }}</p>
      </div>
    </div>
    <oie-base-action
      v-tooltip.top="tStatic('addToCartTooltip')"
      class="invoice-history-row__buy"
      size="medium"
      @click="handleAddToCart">
      <oie-base-icon icon="shopping-cart-plus" size="s"></oie-base-icon>
    </oie-base-action>
  </div>
</template>

<script>
import myPages from '@/mixins/my-pages'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  mixins: [myPages],
  inject: ['context'],
  props: {
    invoiceRow: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('myMachines', ['myMachines', 'myMachinesFilter', 'filteredMachineOwners', 'filteredMachines'])
  },
  methods: {
    ...mapActions('myMachines', ['getMyMachines', 'getMyMachinesMetaData', 'getVehicles', 'setCurrentMachine', 'setCurrentMachineOwner', 'setMyMachinesFilter']),
    ...mapActions('commerce', ['addToCart']),
    handleSelectMachine(machineID) {
      let machineObject = this.filteredMachines.find(item => item['machineId'] === parseInt(machineID))

      if (!machineObject) {
        for (const machineOwner of this.filteredMachineOwners) {
          machineObject = machineOwner.machines.find(item => item['machineId'] === parseInt(machineID))

          if (machineObject) {
            break
          }
        }
      }

      this.setCurrentMachine(machineObject)
      this.goToSubPage(this.navigationOptions.oieMachineDetails)
    },
    handleAddToCart() {
      const cleanPayload = _.omitBy({ itemId: this.invoiceRow.articleNumber, ...this.context }, _.isNil)
      this.addToCart(cleanPayload)
    }

  }
}
</script>

<style lang="scss">
.invoice-history-row {
  display: flex;
  align-items: flex-start;
  gap: measure(quarter);
  padding: measure(quarter);

  @include media(large) {
    padding: measure(half);
    gap: measure(half);
  }
}

.invoice-history-row__container {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: measure(eighth);

  @include media(large) {
    flex-direction: row;
    gap: measure(half);
  }

}

.invoice-history-row__checkbox {
  flex: 0 0 auto;

  @include media(large) {
    align-self: center;
  }
}

.invoice-history-row__image {
  background-color: color(black);
  height: 60px;
  width: 60px;
  flex-grow: 0;
  flex-shrink: 0;
}

.invoice-history-row__name {
  @include caption;
  position: relative;
  flex: 1 1 auto;

  @include media(large) {
    flex: 1 1 20rem;
  }
}

.invoice-history-row__name:hover {
  text-decoration: underline;
}

.invoice-history-row__description {
  @include body-semi-bold;
  overflow-wrap: break-word;
  word-break: break-all;
}

.invoice-history-row__link {
  @include reset-link;
}

/*
.invoice-history-row__link::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
*/

.invoice-history-row__price {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  flex-wrap: wrap;

  > :first-child {
    @include caption;
    margin-right: measure(eighth);
  }
  > :last-child {
    @include body-semi-bold;
  }

  @include media(large) {
    display: block;
    flex: 0 0 7rem;
  }
}

.invoice-history-row__buy {
  flex: 0 0 auto;

  @include media(large) {
    align-self: center;
  }
}

.invoice-row__owner, .invoice-row__machine {
  display: flex;
  flex-direction: row;
  margin-bottom: .3rem;
}

.invoice-row__owner > button > svg, .invoice-row__machine > button > svg {
  margin-right: .3rem;
}

.invoice-row__owner > button, .invoice-row__machine > button {
  background-color: transparent;
  color: rgb(0, 136, 200);
  text-decoration: none;
  border: none;
  overflow: hidden;
  white-space: nowrap;
  max-width: 10rem;
  text-overflow: ellipsis;
  align-items: center;
  display: flex;
}

.invoice-row__owner > button:hover, .invoice-row__machine > button:hover {
  text-decoration: underline
}

</style>
